import React, { Component } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import { reverse } from 'named-urls';
import routes from '@achievable-me/tundra-wizard/routes';
import { canAuthor, findActiveSubscription } from '@achievable-me/tundra-wizard/auth';
import ProductLayout from '$components/layout/ProductLayout';
import ProductUpgrade from '$components/student/ProductUpgrade';
import Seo from '$components/Seo';

import styles from './styles.scss';

const getDescription = (slug) => {
  switch (slug) {
    case 'finra-sie': {
      return "Pass the FINRA SIE on your first try with Achievable's online course. Includes everything you need: easy-to-read online textbook, 2,000+ review quizzes, and 25+ full-length practice exams.";
    }
    case 'finra-series-7': {
      return "Pass the FINRA Series 7 on your first try with Achievable's online course. Includes everything you need: easy-to-read online textbook, 1,500+ review quizzes, and 20+ full-length practice exams.";
    }
    case 'gre': {
      return "Hit your GRE target score on the first try with Achievable's online course. Includes everything you need: unlimited quantitative practice questions, an easy-to-read online textbook, 10+ verbal / reading comprehension practice exams, 1,5000+ vocabulary words, and instant essay grading.";
    }
    default: {
      return null;
    }
  }
};

class Subscription extends Component {
  renderSubscriptionBlock = ({ product }) => {
    const { currentUser } = this.props;

    if (canAuthor({ user: currentUser, product })) {
      return (
        <div className={styles.description}>
          You don&apos;t need a subscription.
          <br />
          <br />
          Thanks for working with us. <i className="fad fa-smile" />
        </div>
      );
    }

    const activeSubscription = findActiveSubscription({ user: currentUser, product });

    if (activeSubscription) {
      const accessExpiresAt = moment(activeSubscription.expiresAt).format(
        'MMMM Do, YYYY'
      );
      return (
        <div className={styles.description}>
          Thanks for your purchase!
          <br />
          <br />
          Your access expires on {accessExpiresAt}.
        </div>
      );
    }

    return (
      <div className={styles.upgradeContainer}>
        <ProductUpgrade currentUser={currentUser} product={product} />
      </div>
    );
  };

  render() {
    const { currentUser, location, match } = this.props;

    return (
      <ProductLayout currentUser={currentUser} location={location} match={match}>
        {({ product }) => {
          return (
            <div className={styles.layout}>
              <Seo
                title={`Buy ${product.shortName} exam prep`}
                canonical={reverse(routes.study.purchase, { productSlug: product.slug })}
                description={`${getDescription(product.slug)} Only ${numeral(
                  product.price
                ).format('$0,0')}.`}
              />
              <h1 className={styles.header}>Purchase {product.shortName}</h1>
              {this.renderSubscriptionBlock({ product })}
            </div>
          );
        }}
      </ProductLayout>
    );
  }
}

export default Subscription;
